import { PayloadAction } from "@reduxjs/toolkit";
import api from "../../providers/api";
import history from "../../providers/history";
import { GetObject } from "../../providers/storage";
import {
  IAuthenticatedUser,
  IAuthenticationPayloadRequest,
  IChangePasswordSaveRequestPayload,
} from "./types";

export const authenticationRequestService = (
  action: PayloadAction<IAuthenticationPayloadRequest>
) => {
  return api.post("users/authenticate/", {
    username: action.payload.username,
    password: action.payload.password,
  });
};

export const changePasswordSaveRequestService = (
  changePassword: IChangePasswordSaveRequestPayload
) => {
  const authenticatedUser = GetObject<IAuthenticatedUser>("authenticatedUser");

  if (!authenticatedUser) return history.replace("/login");

  return api.put(`users/change-password`, changePassword, {
    headers: {
      Authorization: `Bearer ${authenticatedUser.token}`,
    },
  });
};

export const profileUserRequestService = () => {
  const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

  if (!authenticatedUser) return history.replace('/login');
  return api.get('users/get-profile/', {
    headers: {
        Authorization: `Bearer ${authenticatedUser.token}`
    }
  });
};